import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { doPost } from "../../../config/fetchWrapper";
import { urls } from "../../endPoints";

export const importMasterQuestions = createAsyncThunk(
  "importMasterQuestions",
  async (arg, { rejectWithValue }) => {
    try {
      const response = await doPost(urls?.importMasterQuestions, arg);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const importMasterQuestionsSlice = createSlice({
  name: "importMasterQuestions",
  initialState: {
    isLoading: false,
    success: false,
    data: false,
    error: null,
  },
  reducers: {
    importMasterQuestionsReset: () => {
      return {
        isLoading: false,
        success: false,
        data: false,
        error: null,
      };
    },
  },
  extraReducers: {
    [importMasterQuestions.pending]: (state) => {
      state.isLoading = true;
      state.error = null;
      state.success = false;
    },
    [importMasterQuestions.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.error = false;
      state.success = true;
      state.data = payload;
    },
    [importMasterQuestions.rejected]: (state, { payload }) => {
      state.isLoading = false;
      state.error = payload;
      state.data = false;
    },
  },
});

export const { importMasterQuestionsReset } =
  importMasterQuestionsSlice.actions;
